import { getErrors } from "../../../functions/errors/GetErrors"
import { takeDataArray } from "../../../functions/shared/api/adapters"
import { endpoints } from "../../../functions/shared/api/apiConfig"
import { apiFetch } from "../../../functions/shared/api/client"
import { getQueryUnits } from "../../../functions/shared/api/queries/getQueryUnits"
import { createLoaderThunk } from "../../../functions/shared/api/thunkFactory"
import { ACCESS_KEY, urlAPI } from "../../../urls"
import { unitsSlice } from "../../slices/unitsSlice"
import { type AppDispatch, type RootState } from "../../store"

// export const fetchUnits = (noLading?: boolean) => {
//     const jwt = window.localStorage.getItem(ACCESS_KEY)
//     // const userID = window.localStorage.getItem(USER_ID_KEY)
//     return async (dispatch: AppDispatch, getState: () => RootState) => {
//         if (noLading !== true) {
//             dispatch(unitsSlice.actions.unitsFetching())
//         }
//         try {
//             const bodyObject = {
//                 method: 'GET',
//                 collection: 'units',
//                 query: getQueryUnits()
//             }

//             const response = await fetch(`${urlAPI}`, {
//                 method: 'POST',
//                 headers: {
//                     'Content-Type': 'application/json',
//                     Authorization: `Bearer ${jwt}`
//                 },
//                 body: JSON.stringify(bodyObject)
//             })
//             const responseJSON = await response.json()
//             console.log(responseJSON,"responseJSON <<<< ===== responseJSON")
//             if (responseJSON.success) {
//                 if (responseJSON.response.error != null) {
//                     dispatch(unitsSlice.actions.unitsFetchingError(getErrors(responseJSON)))
//                     return { ...responseJSON, textNavigate: '', isSuccessful: false, textNotification: getErrors(responseJSON) }
//                 } else {
//                     dispatch(unitsSlice.actions.unitsFetchingSuccess(responseJSON?.response?.data))
//                     return { ...responseJSON, textNavigate: '', isSuccessful: true, textNotification: '' }
//                 }
//             } else {
//                 dispatch(unitsSlice.actions.unitsFetchingError(getErrors(responseJSON)))
//                 return { textNavigate: '', isSuccessful: false, textNotification: '' }
//             }
//         } catch (error) {
//             console.log(error)
//             dispatch(unitsSlice.actions.unitsFetchingError(JSON.stringify(error)))
//             return { textNavigate: '', isSuccessful: false, textNotification: '' }
//             // dispatch(unitsSlice.actions.unitsFetchingError(error as Error))
//         }
//     }
// }



export const fetchUnits = createLoaderThunk(
    'fetchUnits',
    {
        start:  () => unitsSlice.actions.unitsFetching(),
        success: (arr: any[]) =>{
            return  unitsSlice.actions.unitsFetchingSuccess(arr)
        },
        error:  (msg: string) => unitsSlice.actions.unitsFetchingError(msg),
    },
    async () =>
        await apiFetch<any[]>({ 
            v2:     { path: endpoints.adminRequests.units    },// ,  params : getQueryUnits() , params : getQueryUnits() 
            legacy: { collection: 'units', query: getQueryUnits() },
            adapter: takeDataArray,
            noLimit: true,
        })
);


export const fetchPublicUnits = createLoaderThunk<any[]>(
    'fetchPublicUnits',
    {
        success: (_payload: any[]) => ((_: any) => {}) as any,
    },
    async () =>
        await apiFetch<any[]>({
            v2: { path: endpoints.agentLoader.unitsPublic },
            legacy: { collection: 'units', query:{
                filters: {
                    $and: [
                        { Property: { Area: { $notNull: true } } },
                        {
                            $or: [
                                { Statuses: { $containsi: 'Building Management' } },
                                { Statuses: { $containsi: 'Keys in BSO office' } },
                                { Statuses: { $containsi: 'Digital lock' } },
                                { Statuses: { $containsi: 'Vacant' } },
                                { Statuses: { $containsi: 'Occupied' } },
                                { Statuses: { $containsi: 'Door open' } },
                                { Statuses: { $containsi: 'Door closed' } },
                                { Statuses: { $containsi: 'Agent Unit' } },
                                { Statuses: { $containsi: 'Landlord Unit' } }
                            ]
                        },
                        { Marketing: { Use: { $notNull: true } } },
                        { User: { id: { $notNull: true } } },
                        { ManagedBy: { $notNull: true } },
                    ]
                },
                populate: {
                    Property: { fields: ['Area'] },
                    Statuses: true,
                    User: { fields: ['id'] },
                }
            } },
            adapter: takeDataArray,
        })
);